const mailTo = (subject, body) => {
	const mail = document.createElement('a');
	mail.href = `mailto:rambam.haazinu@gmail.com?subject=${subject}`;
	mail.target = '_blank';
	mail.click();
};

export { mailTo };